<app-header *ngIf="showHead==true"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="showHead==true"></app-footer>
<ngx-ui-loader></ngx-ui-loader>